<template>
  <!--container-->
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        Option
      </h2>

      <div class="link_location">
        설정 <v-icon small class="mdi mdi-chevron-right" />
        일반설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/cms-setting">Option</a>
      </div>

    </div>

    <!--table card-->
    <v-card class="pa-5" elevation="0">
      <v-row>
        <v-col class="mr-3">
          <IconCard :isActive="playerOption === 0" title="Plyr"
            txt="Plyr은 사용하기 쉬운 API와 다양한 사용자 지정 옵션을 제공하여 미디어 재생을 관리 할 수 있습니다." iconColor="green"
            @select="playerOption = 0" class="mb-3" />

          <IconCard :isActive="playerOption === 1" title="video"
            txt="비디오 플레이어는 웹 페이지에서 비디오를 재생하는 도구로, 사용자가 비디오를 시청하고 제어할 수 있습니다." iconBoxColor="green"
            backgroundColor="green" iconColor="green" @select="playerOption = 1" />
        </v-col>
        <!-- <v-col>
          
        </v-col> -->
      </v-row>

    </v-card>

    <v-row justify="end" class="bg-purple">
      <TextButton :disabled="dialog" :loading="dialog" @click="changeRadioSelected" isPrimary class="mt-2">
        SAVE
      </TextButton>
    </v-row>

    <!-- <AppSnackbar :show-snackbar="snackbar" :snackbar-text="snackbarText" :show-snackbar-error="snackbarError"
      :snackbar-error-text="snackbarErrorText" @update:showSnackbar="snackbar = $event"
      @update:showSnackbarError="snackbarError = $event" /> -->

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />



  </div>
</template>

<script>
import UserApi from "@/api/user/UserApi";
// import AppSnackbar from "@/components/app/AppSnackbar.vue";
import IconCard from "@/components/ui/card/IconCard.vue";
import TextButton from '@/components/ui/button/TextButton2.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";


export default {
  components: {
    AppSnackbar,
    IconCard,
    TextButton,
  },
  data() {
    return {
      dialog: false,
      playerOption: null,
      pOptions: [
        { label: 'Plyr', value: 0 },
        { label: 'Video', value: 1 },
      ],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',

    }
  },
  mounted() {
    this.userPlayerOption();
  },
  methods: {
    async userPlayerOption() {
      const response = await UserApi.playeroptionApi();
      if (response.status === 1) {
        this.playerOption = response.data;
      } else {
        console.error('Error:', response.message);
        return null;
      }
    },
    async changeRadioSelected() {
      const data = {
        player_option: this.playerOption
      }
      console.log("data", data);
      const response = await UserApi.playeroptionChange(data);
      if (response.status === 1) {
        this.snackbarText = '변경 성공';
        this.snackbarError = false;
        this.snackbar = true;
      } else {
        this.snackbarText = '생성 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    }
  },
}
</script>

<style scoped>
/* .drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
} */

.drop-area p {
  margin: 0;
}

.hovered-card {
  background-color: #f0f0f0;
  /* 호버 상태에서의 배경 색상 설정 */
}


.centered-text {
  line-height: 100px;
  font-size: 20px;
  color: #d7d7d7
}

.dotted-outline-card {
  border: 2px dashed #e3e3e3;
  /* 점선 아웃라인 스타일의 테두리와 색상 설정 */
  transition: background-color 0.3s;
}

.custom-data-table>>>.v-data-table__wrapper table tbody tr td {
  font-size: 13px;
}
</style>